import {
  SET_LIST_COURSE_SESSION_DATA,
  SET_LIST_COURSE_SESSION_DATA_TOTAL,
} from "../constant/actionTypes";

const initial_state = {
  listCourseSessionData: null,
  listCourseSessionDataTotal: 0,
};

export default (state = initial_state, action) => {
  switch (action.type) {
    case SET_LIST_COURSE_SESSION_DATA:
      return {
        ...state,
        loading: false,
        listCourseSessionData: action.listCourseSessionData,
      };

    case SET_LIST_COURSE_SESSION_DATA_TOTAL:
      return {
        ...state,
        loading: false,
        listCourseSessionDataTotal: action.listCourseSessionDataTotal,
      };

    default:
      return { ...state };
  }
};
